<!--Header-->
    <div class="col-md-12 col-sm-12 col-12 mobAddLed">
        <div class="row">
            <div class="col-md-10 col-sm-10 col-10" style="padding-left: 0px;padding: 15px;">
                <h4 class="modal-title"><span id="ApntmntHdr">Opening Date of Accounts</span></h4>
            </div>
            <div class="col-md-2 col-sm-2 col-2" style="padding: 15px;">
                <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeModal('closed')"></i>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="col-md-12 col-sm-12 col-12 mobAddLed webView">
        <div>Please select an opening date of accounts in Biziverse: </div>
        <div>
            <mat-radio-group aria-label="Select an option" [(ngModel)]="selAcct.finYearVal" (ngModelChange)="changeAcctStartDT()">
                <mat-radio-button value="1">01-Apr-25 (This FY)</mat-radio-button>
                <mat-radio-button value="2">24-May-25 (Today)</mat-radio-button>
                <mat-radio-button value="3">
                    Other
                    <span *ngIf="selAcct.finYearVal == '3'" class="dtpicker" style="margin-right: 25px;margin-left: 15px;font-size: 12px !important; color: #daa520 !important;">
                        <input [min]="selAcct.minDT" [max]="selAcct.maxDT" matInput [matDatepicker]="selAcctDT" [(ngModel)]="selAcct.acctStartDT" (focus)="selAcctDT.open()"
                            class="formCtlFltr form-control bgwhite" readonly (ngModelChange)="changeAcctStartDT()"
                            style="color:#555 !important;display: inline-block; width: 80px; background: #FFF; cursor: pointer;font-size: 13px;text-indent: 5px;vertical-align: middle;">
                        <mat-datepicker-toggle matSuffix [for]="selAcctDT" style="vertical-align: middle; color:#daa520 !important"></mat-datepicker-toggle>  
                        <mat-datepicker #selAcctDT></mat-datepicker>
                    </span>
                </mat-radio-button>
            </mat-radio-group>
        </div>

        <div class="row" style="margin-bottom: 15px;">
            <div class="col-md-12 col-sm-12 col-12">
                <div class="orangeButton brdrRadius3" (click)="saveAccountStartDate()"
                    style="font-size: 14px; cursor: pointer; margin-top: 10px; width: auto;">
                    <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
                    <span>Save Account Opening Date</span>
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-12" style="margin-top: 10px; line-height: 18px">
                <span style="font-size: 12px; font-style: italic; color: #808080;">
                    (Note: The account opening date cannot be changed once ledger entries have been added. It can only be modified if all data is reset.)
                </span>
            </div>
        </div>
    </div>